import { render, staticRenderFns } from "./activity-statistics.vue?vue&type=template&id=20531048&scoped=true&"
import script from "./activity-statistics.vue?vue&type=script&lang=js&"
export * from "./activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./activity-statistics.vue?vue&type=style&index=0&id=20531048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20531048",
  null
  
)

export default component.exports